import {get } from '@/utils/request'

export function getPublicWelfarePager (data) {
  return get('/public/welfare/publicWelfarePager', data)
}